const products = [
  { id: 1, className: 'flex-1', name: '肠肝脑养护', label: 6000, tag: '' },
  { id: 2, className: 'flex-1', name: '肠肝脑养护-疗程', label: 15000, tag: '' },
  { id: 3, className: 'flex-1', name: '血液净化', label: 29800, tag: '' }
];

export const list = [products];
export const expendList = products;
